<div class="area-cabecalho"></div>
<header
    #headerElement
    [style]="{ position: headerPosition, zIndex }"
    [@position]="{ value: positionAnimationState, params: { deslocamento: deslocamentoAoOcultar } }"
    [@background]="backgroundState"
>
    <nav class="accessibility">
        <div>
            <a target="_blank" href="https://www.gov.br/pt-br">
                <img alt="Logo do gov.br" src="/svg/govbr-logo-large-1.svg" />
            </a>
            <p class="body4 regular">Ministério da Educação</p>
        </div>
        <ul>
            <li>
                <a href="https://www.gov.br/pt-br/orgaos-do-governo" class="body5 regular" target="_blank"
                    >Órgãos do Governo</a
                >
            </li>
            <li>
                <a href="https://www.gov.br/acessoainformacao/pt-br" class="body5 regular" target="_blank"
                    >Acesso à Informação</a
                >
            </li>
            <li>
                <a href="https://www4.planalto.gov.br/legislacao" class="body5 regular" target="_blank">Legislação</a>
            </li>
            <li>
                <a
                    href="https://www.gov.br/governodigital/pt-br/acessibilidade-digital"
                    class="body5 regular"
                    target="_blank"
                    >Acessibilidade</a
                >
            </li>
        </ul>
    </nav>
    <div class="barra-navegacao">
        <picture class="logo">
            <source
                [attr.media]="mediaMobile"
                srcset="svg/project-logos/Type=simbol,%20Size=LG,%20Gradient=true.svg"
                width="84"
                height="56"
            />
            <img src="svg/project-logos/logotype-xl-gradient.svg" alt="Docentes do Brasil" width="201" height="56" />
        </picture>
        <nav class="tabs">
            <ul>
                <li>
                    <a routerLink="home" routerLinkActive="active" class="body3 regular">home</a>
                </li>
                <li>
                    <a routerLink="painel-indicadores" routerLinkActive="active" class="body3 regular">indicadores</a>
                </li>
                <li
                    (mouseenter)="abrirMenu('outrasConsultas')"
                    (mouseleave)="fecharMenu()"
                    (focusout)="fecharMenuSeFocoSaiu($event)"
                >
                    <button
                        type="button"
                        class="body3 regular"
                        [class.active]="isPaineisAnaliticosRoute"
                        [attr.aria-expanded]="menuAberto === 'outrasConsultas'"
                        (click)="alternarMenu('outrasConsultas')"
                    >
                        outras consultas
                        <span
                            appIcone="chevron-down"
                            class="chevron"
                            [class.aberto]="menuAberto === 'outrasConsultas'"
                            aria-hidden="true"
                        ></span>
                    </button>
                    @if (menuAberto === 'outrasConsultas') {
                        <app-menu-flutuante
                            animate.enter="entrando"
                            animate.leave="saindo"
                            [opcoes]="opcoesOutrasConsultas"
                        />
                    }
                </li>
                <li>
                    <a routerLink="sobre" routerLinkActive="active" class="body3 regular">sobre</a>
                </li>
                <li class="li-ficha-tecnica">
                    <a class="body3 regular fichas-tecnicas" appFichaTecnica href="#">
                        fichas técnicas
                        <span appIcone="download"></span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</header>
